import * as React from 'react';
import Text from '../Text';

const Heading = ({
  fontSize = 'heading.1',
  fontWeight = 'display',
  fontFamily = 'display',
  lineHeight = 'display',
  as = 'h1',
  ...rest
}) => {
  return (
    <Text
      as={as}
      fontSize={fontSize}
      fontWeight={fontWeight}
      fontFamily={fontFamily}
      lineHeight={lineHeight}
      {...rest}
    />
  );
};

export default Heading;
